import React, { useEffect, useMemo, useState } from "react";
import { backend_url } from "../App";
import "./CSS/BoutiqueDashboard.css";

const CATEGORIES = ["Retail", "Boutique", "Reseller", "VIP"];

const BoutiqueDashboard = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${backend_url}/api/customers`)
      .then((r) => r.json())
      .then((data) => {
        if (data.success) setCustomers(data.customers);
      })
      .catch(() => setCustomers([]))
      .finally(() => setLoading(false));
  }, []);

  const categoryCounts = useMemo(() => {
    const counts = { Retail: 0, Boutique: 0, Reseller: 0, VIP: 0 };
    customers.forEach((c) => {
      counts[c.customerCategory || "Retail"] = (counts[c.customerCategory || "Retail"] || 0) + 1;
    });
    return counts;
  }, [customers]);

  const recentCustomers = useMemo(() => {
    return [...customers]
      .sort((a, b) => new Date(b.registeredOn || 0) - new Date(a.registeredOn || 0))
      .slice(0, 6);
  }, [customers]);

  const maxCategoryCount = Math.max(1, ...Object.values(categoryCounts));

  return (
    <div className="bdash-page">
      <div className="bdash-banner">
        <h2>🧵 Boutique Dashboard</h2>
        <p>Live customer data below. The rest of the tailoring workflow (fabric, orders, production, payments…) lands as each phase ships.</p>
      </div>

      <div className="bdash-stats">
        <div className="bdash-stat-card">
          <div className="bdash-stat-value">{loading ? "…" : customers.length}</div>
          <div className="bdash-stat-label">Total Customers</div>
        </div>
        {CATEGORIES.map((cat) => (
          <div className="bdash-stat-card" key={cat}>
            <div className="bdash-stat-value">{loading ? "…" : categoryCounts[cat]}</div>
            <div className="bdash-stat-label">{cat}</div>
          </div>
        ))}
      </div>

      <div className="bdash-grid">
        <div className="bdash-card">
          <h3>Customer Category Breakdown</h3>
          {loading ? (
            <p className="bdash-empty">Loading…</p>
          ) : customers.length === 0 ? (
            <p className="bdash-empty">No customers yet.</p>
          ) : (
            <div className="bdash-bars">
              {CATEGORIES.map((cat) => (
                <div className="bdash-bar-row" key={cat}>
                  <span className="bdash-bar-label">{cat}</span>
                  <div className="bdash-bar-track">
                    <div
                      className={`bdash-bar-fill bdash-bar-${cat.toLowerCase()}`}
                      style={{ width: `${(categoryCounts[cat] / maxCategoryCount) * 100}%` }}
                    />
                  </div>
                  <span className="bdash-bar-count">{categoryCounts[cat]}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="bdash-card">
          <h3>Recently Registered</h3>
          {loading ? (
            <p className="bdash-empty">Loading…</p>
          ) : recentCustomers.length === 0 ? (
            <p className="bdash-empty">No customers yet.</p>
          ) : (
            <ul className="bdash-recent-list">
              {recentCustomers.map((c) => (
                <li key={c.id} className="bdash-recent-row">
                  <div className="bdash-recent-avatar">
                    {(c.name || "?").charAt(0).toUpperCase()}
                  </div>
                  <div className="bdash-recent-info">
                    <span className="bdash-recent-name">{c.name || "—"}</span>
                    <span className="bdash-recent-meta">{c.customerId || "No ID yet"} · {c.customerCategory}</span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className="bdash-pending-note">
        Fabric, production, QC, payment, delivery, CRM and full analytics reports are not built yet — see the sidebar for what's coming next.
      </div>
    </div>
  );
};

export default BoutiqueDashboard;
